export const BALSAS_CENTER = [-7.53, -46.04];
export const TRAFFIC_TYPES = { colisao: 'Colisão', atropelamento: 'Atropelamento', capotamento: 'Capotamento', tombamento: 'Tombamento', choque: 'Choque contra objeto fixo', queda: 'Queda de ocupante', outros: 'Outros', nao_informado: 'Não informado' };
export const TRAFFIC_SEVERITIES = { sem_vitimas: 'Sem vítimas', nao_fatal: 'Com vítimas não fatais', fatal: 'Fatal', nao_informada: 'Não informada' };
export const SEVERITY_COLORS = { sem_vitimas: '#17834b', nao_fatal: '#c76a10', fatal: '#c22738', nao_informada: '#596579' };

// Screen grid, recalculated on zoom. The anchor is a real coordinate; grouped
// counts are occurrences, not people. No new incident coordinates are created.
export function clusterLocations(locations, project, pixels = 64) {
  const groups = new Map();
  locations.forEach(point => {
    const pixel = project(point.latitude, point.longitude);
    const key = `${Math.floor(pixel.x / pixels)}:${Math.floor(pixel.y / pixels)}`;
    let group = groups.get(key);
    if (!group) {
      group = { key, latitude: point.latitude, longitude: point.longitude, total: 0, bounds: [] };
      groups.set(key, group);
    }
    group.total += point.weight;
    group.bounds.push([point.latitude, point.longitude]);
  });
  return [...groups.values()];
}
